import { Button, Form, Input, InputNumber, Modal, Radio, Select, Tabs, Tooltip, message } from 'antd';
import React, { useState } from 'react';
import ZenVerBarChart from '../components/ManagerDashboard/Common/Graph/ZenVerBarChart';
import ZenPareto from '../components/ManagerDashboard/Common/Graph/ZenPareto';
import ZenHorBarChart from '../components/ManagerDashboard/Common/Graph/ZenHorBarChart';
import SparkTable from './InputCreater/SparkTable';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import { FaChartPie, FaPencilAlt, FaTable } from "react-icons/fa";
import FlameTable from './InputCreater/FlameTable';
import StAddNew from './DSeries/StAddNew';
import ZenDonut from '../components/ManagerDashboard/Common/Graph/ZenDonut';
import Angela1C from '../components/ManagerDashboard/Common/Angela/Angela1C';

const DynamicChart = ({
    LocalDict,
    divid,
    chart,
    setchartid,
    onDelete,
    urlParams,
    chartLists,
    setChartLists,
    chartid,
    currentChart
}) => {
    const [form] = Form.useForm();
    const [chartTab, setChartTab] = useState('');
    const [chartDataSource, setChartDataSource] = useState('');
    const [visibleChart, setVisibleChart] = useState(true);
    const [refreshChart, setRefreshChart] = useState(false);
    const [selectedChart, setSelectedChart] = useState('ZenVerBarChart');
    const [editModal, setEditModal] = useState({
        open: false,
        params: {},
        type: ''
    });
    const [chartParams, setChartParams] = useState({});
    const onFinish = (values) => {
        // console.log('finish', values);
        let formData = {};
        formData['chartParams'] = {
            divid,
            chartTyp: chart,
            chartid,
            isVirgin: currentChart.isVirgin
        };
        formData['pageParams'] = {
            ...urlParams
        };
        Object.keys(values).sort().forEach(x => {
            let key = x.split('lira-spark-')[1].split("--");
            formData['formData'] = {
                ...formData['formData'],
                [key[1]]: values[x]
            }
            delete values[x];
        });
        // setVisibleChart(false);
        liracrypt.post('/dynamicchart/flametable', formData)
            .then(({ data }) => {
                console.log(data);
                if (data.isSuccess) {
                    cancelEditModal();
                    let __charts = [...chartLists];
                    let index = __charts.findIndex(x => x.divid === divid);
                    // let chartName = __charts[index].chart;
                    __charts[index] = {
                        ...__charts[index],
                        isVirgin: false
                    };
                    setVisibleChart(true);
                    setRefreshChart(true);
                    setTimeout(() => {
                        setRefreshChart(false);
                    }, 2000);
                    setChartLists(__charts);
                }
            }).catch(err => {
                console.log(err);
            })
    };
    const cancelEditModal = () => {
        setChartTab('');
        setTimeout(() => {
            setEditModal({
                open: false,
                params: {},
                type: ''
            })
        }, 200);
    };

    const openEditModal = (type) => {
        setEditModal({
            open: true,
            params: {},
            type
        })
    };
    const onChartChange = ({ selectedChart }) => {
        let charts = [...chartLists];
        let index = charts.findIndex(x => x.divid === divid);
        charts[index].typ = selectedChart;
        setChartLists(charts);
        cancelEditModal();
    }

    const changeChartForm = (
        <Form
            style={{ width: '80%' }}
            onFinish={onChartChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            size="large"
        >
            <Form.Item name="selectedChart" label="Select Chart">
                <Select
                    value={selectedChart}
                    onChange={setSelectedChart}
                    placeholder="Please Select"
                    options={[
                        { label: 'ZenHorBarChart', value: 'ZenHorBarChart' },
                        { label: 'ZenPareto', value: 'ZenPareto' },
                        { label: 'ZenVerBarChart', value: 'ZenVerBarChart' },
                        { label: 'ZenDonut', value: 'ZenDonut' },
                        { label: 'Angela1C_SingleRow', value: 'Angela1C_SingleRow' },
                    ]}
                />
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                <Button htmlType='submit' type="primary">Submit</Button>
            </div>
        </Form>
    );

    const submitStyle = (values) => {
        liracrypt.post('/insight/chartSize', { ...values, ...urlParams, chartTyp: chart, divid }).then(response => {
            console.log(response);
            message.success(
                response?.data?.message
                    ? response?.data?.message
                    : "Submitted Successfully"
            );
            cancelEditModal()
        }).catch(err => {
            console.log(err);
            ApiErrorComp(err)
        })
    }
    return (
        <div className={divid} style={{ width: `${100 / chartLists.length}%`, minWidth: '33%', paddingRight: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Tooltip title="Change Chart" color="blue">
                    <Button
                        className='add-new-icon'
                        type="link"
                        icon={
                            <FaChartPie />
                        }
                        onClick={() => openEditModal('chart')}>{''}</Button>
                </Tooltip>
                <Tooltip title="Setting" color="blue">
                    <Button
                        className='add-new-icon'
                        type="link"
                        icon={
                            <i className="fa fa-gear"></i>
                        }
                        onClick={() => openEditModal('setting')}>{''}</Button>
                </Tooltip>
                <Tooltip title="Edit Data" color="green">
                    <Button
                        className='add-new-icon'
                        icon={<FaTable />}
                        type="link" onClick={() => { setChartTab(chartDataSource); openEditModal('flameTable') }}>{''}</Button>
                </Tooltip>
                <Tooltip title="Delete" color="red">
                    <Button
                        className='delete-row-icon'
                        icon={
                            <i className="fa fa-minus-square-o"></i>
                        }
                        type="link" onClick={onDelete}>{''}</Button>
                </Tooltip>
            </div>
            {
                chart ?
                    <div className='chart-container' style={{ boxShadow: "rgb(23 23 23) 5px 5px 9px, rgb(35 35 35) -5px -5px 9px", padding: 10, marginLeft: 10, marginBottom: 10 }}>
                        {
                            (chart === 'ZenVerBarChart' && visibleChart) && (
                                <ZenVerBarChart
                                    refreshChart={refreshChart}
                                    setChartDataSource={setChartDataSource}
                                    divId={divid}
                                    onChange={(data) => this.changeBasicGraph(data)}
                                    api={"/insight/charttemplate"}
                                    setChartId={setchartid}
                                    urlData={{
                                        ...chartParams,
                                        ...urlParams,
                                        //chartGroup: "ZenChartArsenal",
                                        divId: divid,
                                        isVirgin: currentChart.isVirgin,
                                        chartTyp: chart
                                    }}
                                />
                            )
                        }
                        {
                            (chart === 'ZenPareto' && visibleChart) && (
                                <ZenPareto
                                    setChartDataSource={setChartDataSource}
                                    refreshChart={refreshChart}
                                    divId={divid}
                                    api={"/insight/charttemplate"}
                                    setChartId={setchartid}
                                    urlData={{
                                        ...chartParams,
                                        ...urlParams,
                                        //chartGroup: "ZenChartArsenal",
                                        divId: divid,
                                        isVirgin: currentChart.isVirgin,
                                        chartTyp: chart
                                    }}
                                />
                            )
                        }
                        {
                            (chart === 'ZenHorBarChart' && visibleChart) && (
                                <ZenHorBarChart
                                    setChartDataSource={setChartDataSource}
                                    refreshChart={refreshChart}
                                    setChartId={setchartid}
                                    divId={divid}
                                    api={"/insight/charttemplate"}
                                    urlData={{
                                        ...chartParams,
                                        ...urlParams,
                                        isVirgin: currentChart.isVirgin,
                                        // chartGroup: "ZenChartArsenal",
                                        divId: divid,
                                        chartTyp: chart

                                    }}
                                />
                            )
                        }
                        {
                            (chart === 'ZenDonut' && visibleChart) && (
                                <ZenDonut
                                    setChartDataSource={setChartDataSource}
                                    refreshChart={refreshChart}
                                    setChartId={setchartid}
                                    divId={divid}
                                    api={"/insight/charttemplate"}
                                    urlData={{
                                        ...chartParams,
                                        ...urlParams,
                                        isVirgin: currentChart.isVirgin,
                                        // chartGroup: "ZenChartArsenal",
                                        divId: divid,
                                        chartTyp: chart

                                    }}
                                />
                            )
                        }
                        {
                            (chart === 'Angela1C_SingleRow' && visibleChart) && (
                                <Angela1C
                                    setChartDataSource={setChartDataSource}
                                    refreshChart={refreshChart}
                                    setChartId={setchartid}
                                    divId={divid}
                                    api={"/insight/charttemplate"}
                                    urlData={{
                                        ...chartParams,
                                        ...urlParams,
                                        // chartGroup: "ZenChartArsenal",
                                        divId: divid,
                                        chartTyp: chart,
                                        isVirgin: currentChart.isVirgin
                                    }}
                                />
                            )
                        }
                    </div> : <></>
            }

            <Modal
                onCancel={cancelEditModal}
                cancelButtonProps={{ hidden: true }}
                okButtonProps={{ hidden: true }}
                title="Edit"
                open={editModal.open}
                width={'45%'}>
                {
                    editModal.type === 'chart' ?
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            {changeChartForm}
                        </div> : <></>
                }
                {
                    editModal.type === 'flameTable' && (
                        <>
                            {/* <Tabs
                                className='dynamic-charts-tabs'
                                activeKey={chartTab}
                                // defaultActiveKey={chartTab}
                                onChange={e => setChartDataSource(e)}
                                type="card"
                                size='medium'
                                items={[
                                    { key: 'auto', label: 'Auto' },
                                    { key: 'manual', label: 'Manual' },
                                ]}
                            /> */}
                            <div className={'customer-complaint'} style={{ padding: "10px" }}>
                                <div className="customer-form">
                                    <Form
                                        form={form}
                                        labelCol={{ span: 8 }}
                                        layout={"horizontal"}
                                        colon={false}
                                        onFinish={onFinish}
                                        size="large"
                                    >
                                        {
                                            chartTab === '' && (
                                                <></>
                                            )
                                        }
                                        {
                                            chartTab === 'a' && (
                                                <div className='phantom-form'>
                                                    <StAddNew
                                                        colSpan={24}
                                                        urlEndpoint={"/smodal/insight"}
                                                        extraData={{
                                                            chartParams: {
                                                                divid,
                                                                chartTyp: chart,
                                                                chartid,
                                                                isVirgin: currentChart.isVirgin
                                                            },
                                                            pageParams: {
                                                                ...urlParams
                                                            }
                                                        }}
                                                        urlData={{
                                                            dictName: "InsightChartKpi",
                                                            chartParams: JSON.stringify({
                                                                divid,
                                                                chartTyp: chart,
                                                                chartid,
                                                                isVirgin: currentChart.isVirgin
                                                            }),
                                                            pageParams: JSON.stringify({
                                                                ...urlParams
                                                            }),
                                                            // dictName: 'WhyTable2'
                                                        }}
                                                        onCallFinish={() => {
                                                            cancelEditModal();
                                                            let __charts = [...chartLists];
                                                            let index = __charts.findIndex(x => x.divid === divid);
                                                            __charts[index] = {
                                                                ...__charts[index],
                                                                isVirgin: false
                                                            };
                                                            setChartLists(__charts);
                                                            setRefreshChart(true);
                                                            setTimeout(() => {
                                                                setRefreshChart(false)
                                                            }, 2000)
                                                        }}
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            chartTab === 'm' && (
                                                <FlameTable
                                                    LocalDict={LocalDict}
                                                    // label={'Spark Table'}
                                                    labelCol={24}
                                                    form={form}
                                                    api={'/dynamicchart/flametable'}
                                                    params={{
                                                        chartParams: JSON.stringify({
                                                            divid,
                                                            chartTyp: chart,
                                                            chartid,
                                                            isVirgin: currentChart.isVirgin

                                                        }),
                                                        pageParams: JSON.stringify({
                                                            ...urlParams
                                                        }),
                                                        // dictName: 'WhyTable2'
                                                    }}
                                                    colSpan={24}
                                                //  layoutPosition={layoutPosition}
                                                />
                                            )
                                        }
                                        {
                                            ((editModal.type === 'flameTable') && (chartTab === 'auto')) ? (
                                                <></>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                                                    <Button htmlType='submit' type="primary">Submit</Button>
                                                </div>
                                            )
                                        }
                                    </Form>
                                </div>
                            </div>
                        </>
                    )
                }
                {
                    editModal.type === 'setting' && (
                        <div className='phantom-form'>
                            <StAddNew
                                colSpan={24}
                                urlEndpoint={"/smodal"}
                                extraData={{
                                    chartParams: {
                                        divid,
                                        chartTyp: chart,
                                        chartid,
                                        isVirgin: currentChart.isVirgin
                                    },
                                    pageParams: {
                                        ...urlParams
                                    }
                                }}
                                urlData={{
                                    dictName: "InsightChartSetting",
                                    chartParams: JSON.stringify({
                                        divid,
                                        chartTyp: chart,
                                        chartid,
                                        isVirgin: currentChart.isVirgin
                                    }),
                                    pageParams: JSON.stringify({
                                        ...urlParams
                                    }),
                                    // dictName: 'WhyTable2'
                                    // dictName: "InsightChartSetting"
                                }}
                                onCallFinish={() => {
                                    cancelEditModal();
                                    setRefreshChart(true);
                                    setTimeout(() => {
                                        setRefreshChart(false)
                                    }, 2000)
                                }}
                            />
                        </div>
                    )
                }
            </Modal>


        </div>
    )
};

export default DynamicChart;